<template>
  <div id="room">
      <router-view v-if="isRouterAlive"></router-view>
  </div>
</template> 
<script>
export default {
  name: 'room',
  provide (){
     return {
       reload:this.reload
     }
  },
  data(){
    return {
       isRouterAlive: true
    }
  },
  methods:{
    reload (){
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    }
  },
  components:{
  }
}
</script>


// WEBPACK FOOTER //
// src/views/videoRoom/index.vue